/**
 * Компонент нижней панели заказа
 *
 * Прилипает к низу экрана и показывает:
 * - Количество выбранных позиций
 * - Общую сумму заказа
 * - Кнопку для просмотра деталей заказа
 */
import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { SelectedDishItem } from '../types';
import { formatPrice } from '../../../config/currency';

interface OrderBottomBarProps {
  selectedDishes: SelectedDishItem[];
  total: number;
  onOpenDetails: () => void;
}

export const OrderBottomBar: React.FC<OrderBottomBarProps> = ({
  selectedDishes,
  total,
  onOpenDetails,
}) => {
  const { t } = useLanguage();

  // Не показываем панель если нет выбранных блюд
  if (selectedDishes.length === 0) {
    return null;
  }

  // Общее количество всех порций
  const totalQuantity = selectedDishes.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-primary-500 shadow-2xl z-40">
      <div className="container-app max-w-6xl">
        <button
          onClick={onOpenDetails}
          className="w-full py-4 px-6 flex items-center justify-between hover:bg-background-50 transition-colors"
        >
          {/* Левая часть: количество и текст */}
          <div className="flex items-center gap-3">
            {/* Бейдж с количеством */}
            <div className="w-10 h-10 bg-primary-500 text-white rounded-full flex items-center justify-center font-bold text-lg">
              {totalQuantity}
            </div>
            <div className="text-left">
              <div className="font-semibold text-text-primary">
                {t('addOrder.viewOrder')}
              </div>
              <div className="text-sm text-text-secondary">
                {selectedDishes.length} {t('addOrder.itemsCount')}
              </div>
            </div>
          </div>

          {/* Правая часть: сумма и стрелка */}
          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold text-primary-500">
              {formatPrice(total)}
            </span>
            <svg
              className="w-6 h-6 text-primary-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </button>
      </div>
    </div>
  );
};
